import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { RecoverySearchModel } from 'app/modules/common/entities/recovery-search.model';
import { RestResponse } from 'app/modules/common/entities/rest.response-generic.model';
import { ApiService } from 'app/modules/common/services/api.service';
import { DateTimeUtilsService } from 'app/modules/common/services/date-time-utils.service';
import { Eliminados } from 'app/modules/common/types/eliminados.type';
import { Observable } from 'rxjs';
import API from '../../common/services/api.config.json';

@Injectable({
    providedIn: 'root'
})
export class RecoveryService {

    constructor(
        private apiServie: ApiService,
        private dateUtils: DateTimeUtilsService
    ) { }


    /**
     * Get abrevacions of all users
     */
    public getUsersAbreviacions(): Observable<RestResponse<string[]>> {
        const url = API.Recovery.getUsersAbreviacions as string;
        return this.apiServie.get(url);
    }


    /**
     * Get abrevacions of all users
     */
    public searchEliminatedRecords(searchModel: RecoverySearchModel): Observable<RestResponse<Eliminados[]>> {
        const url = API.Recovery.search as string;
        return this.apiServie.post(url, searchModel);
    }


    /**
     * Build a recovery search model
     * @param form Recovery search form
     * @returns Recovery search model
     */
    public buildSearchModel(form: UntypedFormGroup): RecoverySearchModel {
        const searchModel = form.value as RecoverySearchModel;

        // add current empresa
        searchModel.empresaId = parseInt(localStorage.getItem("Empresa"));

        // format dates
        if (form.controls.fromDate.value)
            searchModel.fromDate = this.dateUtils.convertMomentForBackend(form.controls.fromDate.value);
        if (form.controls.toDate.value)
            searchModel.toDate = this.dateUtils.convertMomentForBackend(form.controls.toDate.value);

        return searchModel;
    }


    /**
     * Recover a record
     */
    public recover(eliminatedRecord: Eliminados): Observable<RestResponse<null>> {
        const url = API.Recovery.commonEndPoint as string;
        return this.apiServie.post(url, eliminatedRecord);
    }

}
